import React, { Component } from 'react';

const getScrollTop = () => (
  document.body.scrollTop || document.documentElement.scrollTop
);

export default (BaseComponent, { onlyWhenFullyVisible = false} = {}) => {
  class LazyBlock extends Component {
    constructor(props) {
      super(props);

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      // Don't use internal state to track these since they don't actually
      // affect the rendering of anything.
      this.elTop = Infinity;
      this.elBottom = -Infinity;

      this.state = {
        isVisible: false,
        onScreen: false,
      };
    }

    componentDidMount() {
      if (this.boundingEl) {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);

        this.savePosition();
        this.drawIfVisible();
      }
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
      this.drawIfVisible();
    }

    onResize() {
      this.savePosition();
      this.drawIfVisible();
    }

    savePosition(cb) {
      const { top, height } = this.boundingEl.getBoundingClientRect();
      this.elTop = top + getScrollTop();
      this.elBottom = this.elTop + height;
    }

    drawIfVisible() {
      const padding = onlyWhenFullyVisible ? 0 : 100;
      const viewportTop = getScrollTop() - padding;
      const viewportHeight = document.documentElement.clientHeight;
      const viewportBottom = viewportTop + viewportHeight + (padding * 2);

      const isOnScreen = onlyWhenFullyVisible ? (
        this.elTop >= viewportTop && this.elBottom <= viewportBottom
      ) : (
        (this.elTop >= viewportTop && this.elTop <= viewportBottom) ||
        (this.elBottom >= viewportTop && this.elBottom <= viewportBottom) ||
        (this.elTop <= viewportTop && this.elBottom >= viewportBottom)
      )

      if (isOnScreen) {
        this.setState({
          isVisible: true,
          onScreen: true,
        });
      } else {
        this.setState({
          onScreen: false,
        });
      }
    }

    render() {
      return (
        <BaseComponent
          {...this.props}
          isVisible={this.state.isVisible}
          onScreen={this.state.onScreen}
          boundingRef={el => (this.boundingEl = el)}
        />
      );
    }
  }

  return LazyBlock;
};



// WEBPACK FOOTER //
// ./src/components/timeline/LazyBlockHoc.js